import { useContext, useState } from "react";
import { handleDownloadLeadService, handleDownloadSelectedLeadService } from "../pages/leads-management/service/LeadService";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../slices/store";
import { TodosContext } from "../context";
import { LEAD_IDENTIFIERS } from "../pages/leads-management/models/ILead";
import { getParameterOne } from "../components/templates/LeadTemplates/AllLeadsTemplate/utils";

interface PageOption {
  label: string;
  value: number;
}

interface UseDownloadLeadsReturn {
  isConfirmationModalShow: boolean;
  selectedPage: PageOption | null;
  selectedLeadType: PageOption | null;
  handleOpenModal: () => void;
  handleCloseModal: () => void;
  handleConfirm: (lead: LEAD_IDENTIFIERS) => void;
  handleSelectedConfirm: (selectedLeads: number[]) => void;
  setSelectedPage: React.Dispatch<React.SetStateAction<PageOption | null>>;
  setSelectedLeadType: React.Dispatch<React.SetStateAction<PageOption | null>>;
  isLoadingDownloads: boolean;
}

const useDownloadLeads = (protectedResources: any): UseDownloadLeadsReturn => {
  const { addAlert } = useContext(TodosContext);
  const dispatch = useDispatch<AppDispatch>();
  const [isConfirmationModalShow, setIsConfirmationModalShow] =
    useState<boolean>(false);
  const [selectedPage, setSelectedPage] = useState<PageOption | null>(null);
  const [selectedLeadType, setSelectedLeadType] = useState<PageOption | null>(
    null
  );
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenModal = () => setIsConfirmationModalShow(true);
  const handleCloseModal = () => setIsConfirmationModalShow(false);

  const handleConfirm = (lead:LEAD_IDENTIFIERS) => {
    handleCloseModal();

    
    const params = {
      ParameterOne: getParameterOne(lead),
      url: protectedResources.apiTodoList.endpoint,
      accessToken: localStorage.getItem("AccessToken") || "",
    };

    handleDownloadLeadService(params, setIsLoading, dispatch, addAlert);
  };

  const handleSelectedConfirm = (selectedLeads: number[]) => {
    handleCloseModal();
    
    const params = {
      LeadIds: selectedLeads,
      url: protectedResources.apiTodoList.endpoint,
      accessToken: localStorage.getItem("AccessToken") || "",
    };

    handleDownloadSelectedLeadService(params, setIsLoading, dispatch, addAlert);
  };

  return {
    isConfirmationModalShow,
    selectedPage,
    selectedLeadType,
    handleOpenModal,
    handleCloseModal,
    handleConfirm,
    handleSelectedConfirm,
    setSelectedPage,
    setSelectedLeadType,
    isLoadingDownloads: isLoading,
  };
};

export default useDownloadLeads;
